import React from 'react';
import { isEmpty, has } from 'lodash';
import moment from 'moment';
import { Modal, Row, Col, Button, Form, Spinner } from 'react-bootstrap';
import { isMobileOnly } from 'react-device-detect';

import { RenderErrorUI, RenderUploadedFile } from './CommonUploadComponent';
import ImagePreviewModal from '../../../../../CommonComponent/ImagePreviewModal';
import BGVCamera from '../../../../../CommonComponent/BGVCamera';
import Image from '../../../../../../../core-components/Image';
import logger from '../../../../../../../core-components/Logger';
import AppConstants from '../../../../../../../core-components/AppConstants';
import {
  FileErrorMeaage,
  getFileHeader,
  toSnakeCase,
  validateImage
} from '../../../../../../../utils/utilities';
import { obj } from '../../../../../../../utils/commonConstant';
import PasswordProtectedModal from '../../../PasswordProtectedModal';

import styles from './AddEditUpload.module.scss';
import { pdfjs } from 'react-pdf';

class AddEditUpload extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      docUpload: {
        certificate: {},
        gradeSheet: []
      },
      educationCheck: null,
      imagePreviewUrl: '',
      showImagePreviewModal: false,
      isDateCorrect: true,
      noGradeSheetCheckbox: false,
      takeCertificatePhoto: false,
      takeGradesheetPhoto: false,
      isCameraUploadError: false,
      marksheetArr: ['10', '12'],
      bothCertificateMarksheet: [
        'UNDERGRAD',
        'POSTGRAD',
        'PHD',
        '12/Diploma',
        'Other',
        'UG',
        'PG',
        'PHD',
        'Undergraduate',
        'Postgraduate',
        'Post Graduation'
      ],
      showPasswordProtectedModal: false,
      uploadedType: ''
    };
  }

  //image validation before uploading
  validateImage = (fileArr) => {
    let errMessage = '';
    let extensionArr = ['application/pdf', 'image/jpeg', 'image/jpg', 'image/png'];
    const size = parseInt(fileArr.size / 1024);
    const extension = fileArr.type;

    if (size < AppConstants.fileSize && extension !== 'application/pdf') {
      errMessage =
        'Upload failed. Please upload a file that exceeds ' + AppConstants.fileSize + ' KB';
    } else if (!extensionArr.includes(extension)) {
      errMessage = 'Upload failed. File format not valid';
    }
    return errMessage;
  };

  //upload handling for certificate
  handleCertificateUpload = (formData, isPdf, setCameraSubmitting = null, file) => {
    var that = this;

    const reader = new FileReader();
    reader.readAsArrayBuffer(file);
    reader.onload = function (c) {
      if (reader.result) {
        that.setState(
          {
            docUpload: {
              ...that.state.docUpload,
              certificate: { link: '', error: '', loading: true }
            }
          },
          () => {
            that.props
              .educationCertificateUpload({ formData, isPdf })
              .then(() => {
                if (isPdf) {
                  const loadingTask = pdfjs.getDocument({ data: reader.result, password: '' });
                  loadingTask.promise
                    .then((pdfDocument) => {
                      if (setCameraSubmitting && isMobileOnly) {
                        setCameraSubmitting(false);
                      }
                      if (setCameraSubmitting && isMobileOnly) {
                        setCameraSubmitting(false);
                      }
                      that.setState({
                        docUpload: {
                          ...that.state.docUpload,
                          certificate: {
                            link:
                              (that.props.uploadedCertificate &&
                                that.props.uploadedCertificate.link) ||
                              '',
                            error: '',
                            loading: false,
                            isPdf:
                              (that.props.uploadedCertificate &&
                                that.props.uploadedCertificate.isPdf) ||
                              false
                          }
                        },
                        takeCertificatePhoto: false,
                        isCameraUploadError: false
                      });
                    })
                    .catch((error) => {
                      if (error.message == 'No password given') {
                        that.setState({
                          showPasswordProtectedModal: true
                        });
                      }
                    });
                } else {
                  if (setCameraSubmitting && isMobileOnly) {
                    setCameraSubmitting(false);
                  }
                  if (setCameraSubmitting && isMobileOnly) {
                    setCameraSubmitting(false);
                  }
                  that.setState({
                    docUpload: {
                      ...that.state.docUpload,
                      certificate: {
                        link:
                          (that.props.uploadedCertificate && that.props.uploadedCertificate.link) ||
                          '',
                        error: '',
                        loading: false,
                        isPdf:
                          (that.props.uploadedCertificate &&
                            that.props.uploadedCertificate.isPdf) ||
                          false
                      }
                    },
                    takeCertificatePhoto: false,
                    isCameraUploadError: false
                  });
                }
              })
              .catch((error) => {
                console.error(error);
                if (setCameraSubmitting && isMobileOnly) {
                  setCameraSubmitting(false);
                }
                that.setState({
                  docUpload: {
                    ...that.state.docUpload,
                    certificate: {
                      link: '',
                      error: 'Upload failed. File format not valid.',
                      loading: false
                    }
                  },
                  isCameraUploadError: true
                });
              });
          }
        );
      }
    };
  };

  //upload handling for gradesheet
  handleGradesheetUpload = (formData, isPdf, index, setCameraSubmitting = null, file) => {
    var that = this;

    let gradesheetCopy = [...that.state.docUpload.gradeSheet];
    gradesheetCopy[index] = { link: '', error: '', loading: true };

    const reader = new FileReader();
    reader.readAsArrayBuffer(file);
    reader.onload = function () {
      if (reader.result) {
        that.setState(
          {
            docUpload: { ...that.state.docUpload, gradeSheet: [...gradesheetCopy] }
          },
          () => {
            that.props
              .educationGradesheetUpload({ formData, isPdf, index })
              .then(() => {
                try {
                  if (isPdf) {
                    const loadingTask = pdfjs.getDocument({ data: reader.result, password: '' });
                    loadingTask.promise
                      .then((pdfDocument) => {
                        let sheetCopy = [...that.state.docUpload.gradeSheet];
                        sheetCopy[index] = {
                          link: that.props?.uploadedGradesheet?.length
                            ? that.props.uploadedGradesheet[index].link
                            : '',
                          error: '',
                          loading: false,
                          isPdf: that.props?.uploadedGradesheet?.length
                            ? that.props.uploadedGradesheet[index].isPdf
                            : false
                        };

                        if (setCameraSubmitting && isMobileOnly) {
                          setCameraSubmitting(false);
                        }
                        that.setState({
                          docUpload: { ...that.state.docUpload, gradeSheet: [...sheetCopy] },
                          takeGradesheetPhoto: false,
                          isCameraUploadError: false
                        });
                      })
                      .catch((error) => {
                        if (error.message == 'No password given') {
                          that.setState({
                            showPasswordProtectedModal: true
                          });
                        }
                      });
                  } else {
                    let sheetCopy = [...that.state.docUpload.gradeSheet];
                    sheetCopy[index] = {
                      link: that.props?.uploadedGradesheet?.length
                        ? that.props.uploadedGradesheet[index].link
                        : '',
                      error: '',
                      loading: false,
                      isPdf: that.props?.uploadedGradesheet?.length
                        ? that.props.uploadedGradesheet[index].isPdf
                        : false
                    };

                    if (setCameraSubmitting && isMobileOnly) {
                      setCameraSubmitting(false);
                    }
                    that.setState({
                      docUpload: { ...that.state.docUpload, gradeSheet: [...sheetCopy] },
                      takeGradesheetPhoto: false,
                      isCameraUploadError: false
                    });
                  }
                } catch (e) {
                  console.log(e);
                }
              })
              .catch((error) => {
                console.log(error);
                let sheetCopy = [...that.state.docUpload.gradeSheet];
                sheetCopy[index] = {
                  link: '',
                  error: 'Upload failed. File format not valid.',
                  loading: false,
                  password: ''
                };

                if (setCameraSubmitting && isMobileOnly) {
                  setCameraSubmitting(false);
                }
                that.setState({
                  docUpload: { ...that.state.docUpload, gradeSheet: [...sheetCopy] },
                  isCameraUploadError: true
                });
              });
          }
        );
      }
    };
  };
  handleFileSelect = (e, type, index) => {
    let fileType = '';
    var blob = e.target.files[0];
    this.setState({ uploadedType: type });

    var fileReader = new FileReader();
    fileReader.onloadend = () => {
      var arr = new Uint8Array(fileReader.result).subarray(0, 4);
      var header = '';
      for (var i = 0; i < arr.length; i++) {
        header += arr[i].toString(16);
      }
      // Check the file signature against known types
      fileType = getFileHeader(header);
      const errMessage = validateImage(blob, fileType);
      const isPdf = fileType === 'application/pdf' ? true : false;
      if (!errMessage) {
        let formData = new FormData();
        formData.append(`file`, blob);
        formData.append(`file_type`, 'CHECK_DOCUMENT');
        if (type === 'certificate') {
          this.handleCertificateUpload(formData, isPdf, null, blob);
        } else if (type === 'gradesheet') {
          this.handleGradesheetUpload(formData, isPdf, index, null, blob);
        }
      } else {
        if (type === 'certificate') {
          this.setState({
            docUpload: {
              ...this.state.docUpload,
              certificate: { link: '', error: FileErrorMeaage[errMessage], loading: false }
            }
          });
        } else if (type === 'gradesheet') {
          let gradesheetCopy = [...this.state.docUpload.gradeSheet];
          gradesheetCopy[index] = { link: '', error: FileErrorMeaage[errMessage], loading: false };

          this.setState({
            docUpload: { ...this.state.docUpload, gradeSheet: [...gradesheetCopy] }
          });
        }
      }
    };

    if (blob instanceof Blob) {
      {
        /** To avoid TyperError issue reported by sentry, need to check if param is an Blob type or not */
      }
      fileReader.readAsArrayBuffer(blob);
    } else {
      console.error(
        `Failed to execute 'readAsArrayBuffer' on 'FileReader': parameter is not of type 'Blob'`
      );
    }
  };
  //handle change when user select from input type file
  // handleFileSelect = (e, type, index) => {
  //   const errMessage = this.validateImage(e.target.files[0]);
  //   const isPdf = e.target.files[0].type === 'application/pdf' ? true : false;

  //   if (!errMessage) {
  //     let formData = new FormData();
  //     formData.append(`file`, e.target.files[0]);

  //     if (type === 'certificate') {
  //       this.handleCertificateUpload(formData, isPdf);
  //     } else if (type === 'gradesheet') {
  //       this.handleGradesheetUpload(formData, isPdf, index);
  //     }
  //   } else {
  //     if (type === 'certificate') {
  //       this.setState({
  //         docUpload: {
  //           ...this.state.docUpload,
  //           certificate: { link: '', error: errMessage, loading: false }
  //         }
  //       });
  //     } else if (type === 'gradesheet') {
  //       let gradesheetCopy = [...this.state.docUpload.gradeSheet];
  //       gradesheetCopy[index] = { link: '', error: errMessage, loading: false };

  //       this.setState({
  //         docUpload: { ...this.state.docUpload, gradeSheet: [...gradesheetCopy] }
  //       });
  //     }
  //   }
  // };

  //for clearing error.
  clearError = (type, index) => {
    if (type === 'certificate') {
      this.setState({
        docUpload: {
          ...this.state.docUpload,
          certificate: { link: '', error: '', loading: false }
        }
      });
    } else if (type === 'gradesheet') {
      const gradesheetCopy = [...this.state.docUpload.gradeSheet];
      gradesheetCopy.splice(index, 1);
      // gradesheetCopy[index] = { link: '', error: '', loading: false };
      this.setState({ docUpload: { ...this.state.docUpload, gradeSheet: [...gradesheetCopy] } });
    }
  };

  //handling preview of image
  handleImagePreview = (url) => {
    this.setState({
      imagePreviewUrl: url || '',
      showImagePreviewModal: !this.state.showImagePreviewModal
    });
  };

  //handling delete of image
  handleDeleteImage = (type, index) => {
    if (type === 'certificate') {
      this.setState(
        {
          docUpload: {
            ...this.state.docUpload,
            certificate: {}
          }
        },
        () => {
          this.props.setCertificateUpload({});
        }
      );
    } else if (type === 'gradesheet') {
      const gradesheetCopy = [...this.state.docUpload.gradeSheet];
      gradesheetCopy.splice(index, 1);

      this.setState(
        { docUpload: { ...this.state.docUpload, gradeSheet: [...gradesheetCopy] } },
        () => {
          this.props.deleteGradesheetUpload(gradesheetCopy);
        }
      );
    }
  };

  //checkbox when we have to take confirmation that candidate is not having any gradesheet. Commented as asked by product

  // handleCheckbox = (e) => {
  //   if (e.target.checked) {
  //     this.setState({
  //       noGradeSheetCheckbox: e.target.checked,
  //       docUpload: {
  //         ...this.state.docUpload,
  //         gradeSheet: [],
  //         certificate: {}
  //       }
  //     });
  //   } else {
  //     this.setState({ noGradeSheetCheckbox: e.target.checked });
  //   }
  // };

  //for checking any of the image uploaded is not having link, error, loading
  isImageHavingError = () => {
    let isImageHavingError = false;
    for (let value of this.state.docUpload.gradeSheet) {
      if (!value.link || value.error || value.loading) {
        isImageHavingError = true;
        break;
      }
    }
    return isImageHavingError;
  };

  //enabling save button
  // enableSaveBtn = (checkLength = false) => {
  //   let enableBtn = true;
  //   const {
  //     docUpload: { gradeSheet }
  //   } = this.state;

  //   for (let value of gradeSheet) {
  //     if (value.error) {
  //       enableBtn = false;
  //       break;
  //     }
  //   }
  //   if (enableBtn && gradeSheet.length === 1 && !gradeSheet[0].link && !gradeSheet[0].errror) {
  //     enableBtn = true;
  //   }
  //   if (checkLength && gradeSheet.length === 0 && enableBtn) {
  //     return (enableBtn = false);
  //   } else {
  //     return enableBtn;
  //   }
  // };

  isSaveButtonEnable = () => {
    const { educationCheck } = this.state;
    const step1 =
      educationCheck && has(educationCheck, 'step1') && !isEmpty(educationCheck.step1)
        ? educationCheck.step1
        : null;

    if (
      // For 10 and 12
      step1 &&
      this.state.marksheetArr.includes(step1.educationLevel) &&
      this.state.docUpload.gradeSheet.length &&
      !this.isImageHavingError()
      // && this.enableSaveBtn()
    ) {
      return true;
    } else if (
      // for certificate and gradesheet when completed graduation
      step1 &&
      this.state.bothCertificateMarksheet.includes(step1.educationLevel) &&
      this.state.isDateCorrect &&
      this.state.docUpload.gradeSheet.length &&
      this.state.docUpload.certificate.link &&
      !this.isImageHavingError()
    ) {
      return true;
    } else if (
      // for certificate and gradesheet when persuing graduation
      step1 &&
      this.state.bothCertificateMarksheet.includes(step1.educationLevel) &&
      !this.state.isDateCorrect &&
      (this.state.noGradeSheetCheckbox ||
        (!this.state.noGradeSheetCheckbox &&
          this.state.docUpload.gradeSheet.length &&
          !this.isImageHavingError()))
      // (this.enableSaveBtn(true) || this.state.noGradeSheetCheckbox)
    ) {
      return true;
    } else {
      return false;
    }
  };

  handleSubmit = () => {
    const stateCopy = Object.assign({}, this.state.docUpload),
      gradeSheet = stateCopy.gradeSheet.length
        ? stateCopy.gradeSheet.map((value) => {
            return { link: value.link, isPdf: value.isPdf, password: value.password };
          })
        : [],
      certificate =
        !isEmpty(stateCopy.certificate) && stateCopy.certificate.link
          ? {
              link: stateCopy.certificate.link,
              isPdf: stateCopy.certificate.isPdf,
              password: stateCopy.certificate.password
            }
          : {},
      stepObject = {
        certificate,
        gradeSheet: gradeSheet
      };

    const educationCheck = [...this.props.bgvCachedData.cacheData.educationCheck];

    if (this.props.isEdit && !isEmpty(this.props.temporaryEducation)) {
      educationCheck[this.props.currentSavingIndex] = {
        ...this.props.temporaryEducation.saveObject.cacheData.educationCheck[
          this.props.currentSavingIndex
        ]
      };
    }

    educationCheck[this.props.currentSavingIndex]['step2'] = { ...stepObject };
    educationCheck[this.props.currentSavingIndex]['packageCurrentSubstep'] = 1;

    const saveObject = toSnakeCase({
      ...this.props.bgvCachedData,
      cacheData: {
        ...this.props.bgvCachedData.cacheData,
        educationCheck: [...educationCheck]
      },
      currentState: '5'
    });

    const finalCacheObject = {
      saveObject
    };

    this.props
      .setBgvCache(finalCacheObject)
      .then(() => {
        this.props.onHide();

        // logger code
        const loggerObj = {
          message: `Education step2 is ${this.props.isEdit ? 'Edited' : 'Saved'}`,
          data: JSON.stringify(finalCacheObject),
          category: `candidate-id-${this.props.candidateId}`,
          subCategory: 'Education details#2',
          type: 'info'
        };
        logger.push(loggerObj);
      })
      .catch((error) => {
        console.error(error);
      });
  };

  // handle camera certificate photo
  handleCertificatePhoto = () => {
    this.setState({
      takeCertificatePhoto: !this.state.takeCertificatePhoto,
      isCameraUploadError: false
    });
  };

  // handle camera gradesheet photo
  handleGradesheetPhoto = () => {
    this.setState({
      takeGradesheetPhoto: !this.state.takeGradesheetPhoto,
      isCameraUploadError: false
    });
  };

  renderHeading = (educationLevel) => {
    return (
      <p className={styles.degreeCertificateTitle}>
        {educationLevel &&
        this.state.bothCertificateMarksheet.includes(educationLevel) &&
        this.state.isDateCorrect ? (
          <>
            {'Add your degree certificate and all your mark sheets'} <span>*</span>
          </>
        ) : (
          <>
            {'Add your mark sheets'} <span>*</span>
          </>
        )}
      </p>
    );
  };

  renderDescription = (educationLevel) => {
    return (
      <>
        <p className={styles.educationProofTitle}>{'Add your Education proof'}</p>
        <p className={styles.educationProofDescription}>
          {educationLevel &&
          this.state.bothCertificateMarksheet.includes(educationLevel) &&
          this.state.isDateCorrect
            ? 'Please upload your degree certificate and all your mark sheets as proof. Upload .png, .jpg, .jpeg or pdf file only'
            : 'Please upload your mark sheets as proof. Upload .png, .jpg, .jpeg or pdf file only'}
        </p>
      </>
    );
  };

  enableGradesheetBtn = () => {
    let isImageHavingError = false;

    if (isMobileOnly) {
      for (let value of this.state.docUpload.gradeSheet) {
        if (value.error) {
          isImageHavingError = true;
          break;
        }
      }
    }
    return isImageHavingError;
  };

  handleInitialState = () => {
    let educationCheck = null,
      step1 = null;
    const docUploadCopy = Object.assign({}, { ...this.state.docUpload });

    if (this.props.isEdit && !isEmpty(this.props.temporaryEducation)) {
      educationCheck =
        this.props.temporaryEducation.saveObject.cacheData &&
        this.props.temporaryEducation.saveObject.cacheData.educationCheck &&
        this.props.temporaryEducation.saveObject.cacheData.educationCheck.length
          ? this.props.temporaryEducation.saveObject.cacheData.educationCheck[
              this.props.currentSavingIndex
            ]
          : null;
    } else {
      educationCheck =
        this.props.bgvCachedData &&
        this.props.bgvCachedData.cacheData &&
        this.props.bgvCachedData.cacheData.educationCheck &&
        this.props.bgvCachedData.cacheData.educationCheck.length
          ? this.props.bgvCachedData.cacheData.educationCheck[this.props.currentSavingIndex]
          : null;
    }
    step1 = educationCheck && educationCheck.step1 ? educationCheck.step1 : null;

    if (
      educationCheck &&
      (this.props?.uploadedGradesheet?.length || this.props.uploadedCertificate)
    ) {
      docUploadCopy.certificate.link =
        this.props.uploadedCertificate && this.props.uploadedCertificate.link;

      docUploadCopy.certificate.isPdf =
        this.props.uploadedCertificate && this.props.uploadedCertificate.isPdf;
      docUploadCopy.certificate.password =
        this.props.uploadedCertificate && this?.props?.uploadedCertificate?.password;
      docUploadCopy.certificate.error = '';
      docUploadCopy.certificate.loading = false;
      const gradeSheet = this.props.uploadedGradesheet;
      docUploadCopy.gradeSheet = gradeSheet.map((item) => {
        return {
          link: item.link,
          error: '',
          loading: false,
          isPdf: item.isPdf || false,
          password: item.password
        };
      });
    }

    this.setState({
      docUpload: { ...docUploadCopy },
      educationCheck
    });

    // all code blocks are same for now, that's why commented
    // if (
    //   this.props.isEdit &&
    //   ((this.state.bothCertificateMarksheet.includes(step1.educationLevel) &&
    //     moment(step1.datesAttended.endDate, 'MM/YYYY') <= moment()) ||
    //     !this.state.bothCertificateMarksheet.includes(step1.educationLevel))
    // ) {
    //   this.setState({
    //     docUpload: { ...docUploadCopy },
    //     educationCheck
    //     // noGradeSheetCheckbox: false
    //   });
    // } else if (
    //   this.props.isEdit &&
    //   this.state.bothCertificateMarksheet.includes(step1.educationLevel) &&
    //   moment(step1.datesAttended.endDate, 'MM/YYYY') > moment()
    // ) {
    //   this.setState({
    //     docUpload: { ...docUploadCopy },
    //     educationCheck
    //     // noGradeSheetCheckbox: docUploadCopy.gradeSheet.length ? false : true
    //   });
    // } else {
    //   this.setState({
    //     docUpload: { ...docUploadCopy },
    //     educationCheck
    //     // noGradeSheetCheckbox: step2 && step2.noGradeSheet ? true : false
    //   });
    // }

    if (step1) {
      const { endDate } = step1.datesAttended;

      moment(endDate, 'MM/YYYY') > moment() &&
        this.setState({
          isDateCorrect: false
        });
    }
  };

  modalHide = () => {
    this.setState({
      showPasswordProtectedModal: false
    });
    if (this.state.uploadedType === 'certificate') {
      this.setState({
        docUpload: {
          ...this.state.docUpload,
          certificate: { link: '', error: '', loading: false }
        },
        isCameraUploadError: true
      });
    } else if (this.state.uploadedType === 'gradesheet') {
      let docCopy = [...this?.state?.docUpload?.gradeSheet];
      docCopy.splice(this.props.uploadedSingleGradesheet.index, 1);
      this.setState({
        docUpload: { ...this.state.docUpload, gradeSheet: [...docCopy] },
        takePhoto: false,
        isCamHavingError: false
      });
    }
  };

  submitHandlerPasswordModal = (password = '') => {
    //Function for handling submit password when unable to unlock the file and when successfully saved the password
    let docCopy;
    this.setState({
      showPasswordProtectedModal: false
    });
    if (this.state.uploadedType === 'certificate') {
      docCopy = { ...this?.state?.docUpload?.certificate };
      docCopy['link'] = this.props.uploadedSingleGradesheet.link.data;
      docCopy['isPdf'] = true;
      docCopy['loading'] = false;
      docCopy['password'] = password;

      this.setState({
        docUpload: { ...this.state.docUpload, certificate: { ...docCopy } },
        takePhoto: false,
        isCamHavingError: false
      });
      this.props.updateCertificateWithPasswordAction(docCopy);
    } else if (this.state.uploadedType === 'gradesheet') {
      docCopy = [...this?.state?.docUpload?.gradeSheet];
      docCopy[this.props.uploadedSingleGradesheet.index]['link'] =
        this.props.uploadedSingleGradesheet.link.data;
      docCopy[this.props.uploadedSingleGradesheet.index]['isPdf'] = true;
      docCopy[this.props.uploadedSingleGradesheet.index]['loading'] = false;
      docCopy[this.props.uploadedSingleGradesheet.index]['password'] = password;

      this.setState({
        docUpload: { ...this.state.docUpload, gradeSheet: [...docCopy] },
        takePhoto: false,
        isCamHavingError: false
      });
      this.props.updateGradeSheetWithPasswordAction(docCopy);
    }
  };

  componentDidMount() {
    this.handleInitialState();
  }

  render() {
    const educationLevel =
      (this.state.educationCheck &&
        this.state.educationCheck.step1 &&
        this.state.educationCheck.step1.educationLevel) ||
      null;
    const enableBtn = this.isSaveButtonEnable();
    const enableTakePhotoBtn =
      !this.enableGradesheetBtn() && this.state.docUpload.gradeSheet.length < 10;

    const renderGradeSheetHavingLength = () => {
      return this.state.docUpload.gradeSheet.map((item, index) => {
        return item.error ? (
          <Col
            lg={5}
            md={5}
            sm={10}
            xs={10}
            key={`grade_sheet_${index}`}
            className={isMobileOnly ? styles.uploadContainer : null}
          >
            <RenderErrorUI
              handleClick={this.clearError}
              errorText={item.error}
              index={index}
              type='gradesheet'
            />
          </Col>
        ) : item.loading ? (
          <Col
            lg={5}
            md={5}
            sm={10}
            xs={10}
            key={`grade_sheet_${index}`}
            className={isMobileOnly ? styles.uploadContainer : null}
          >
            <div className={styles.certificateInputFileContainer}>
              <Spinner animation='border' variant='primary' />
            </div>
          </Col>
        ) : item.link ? (
          <Col
            lg={5}
            md={5}
            sm={10}
            xs={10}
            key={`grade_sheet_${index}`}
            className={isMobileOnly ? styles.uploadContainer : null}
          >
            <RenderUploadedFile
              item={item}
              handleImagePreview={this.handleImagePreview}
              handleDeleteImage={this.handleDeleteImage}
              type='gradesheet'
              index={index}
              isPdf={item.isPdf}
            />
          </Col>
        ) : (
          <Col
            lg={5}
            md={5}
            sm={10}
            xs={10}
            key={`grade_sheet_${index}`}
            className={isMobileOnly ? styles.uploadContainer : null}
          >
            <label className={styles.certificateInputFileContainer}>
              <div>
                <Image name='certificate_upload_enable.png' />
                <p>{'Add your mark sheet'}</p>
                <Form.Control
                  id='formControlsFile'
                  accept='image/*,application/pdf'
                  type='file'
                  label='File'
                  onChange={(e) => this.handleFileSelect(e, 'gradesheet', index)}
                />
              </div>
            </label>
          </Col>
        );
      });
    };

    const renderUploadGradeSheet = () => {
      return (
        <Col lg={5} md={5} sm={10} xs={10} className={isMobileOnly ? styles.uploadContainer : null}>
          <label className={styles.certificateInputFileContainer}>
            <div>
              <Image name='certificate_upload_enable.png' />
              <p>{'Add your mark sheet'}</p>
              <Form.Control
                id='formControlsFile'
                accept='image/*,application/pdf'
                type='file'
                label='File'
                onChange={(e) =>
                  this.handleFileSelect(e, 'gradesheet', this.state.docUpload.gradeSheet.length)
                }
              />
            </div>
          </label>
        </Col>
      );
    };

    return (
      <>
        <Modal
          size={this.state.showPasswordProtectedModal ? 'sm' : 'lg'}
          show={this.props.show}
          // show={this.state.showPasswordProtectedModal ? false : this.props.show}
          onHide={this.props.onHide}
          dialogClassName='educationModal'
          backdropClassName={'customBGVModalBackdrop'}
        >
          <div style={this.state.showPasswordProtectedModal ? { display: 'none' } : null}>
            <Modal.Header closeButton>
              <Modal.Title id='contained-modal-title-vcenter'>
                <div className={styles.educationModalTitle}>
                  {this.props.isSpecific ? (
                    <span>
                      {this.props.isEdit
                        ? `Edit ${obj[educationLevel]} details`
                        : `Add ${obj[educationLevel]} details`}
                    </span>
                  ) : (
                    <span>{this.props.isEdit ? 'Edit Education' : 'Add Education'}</span>
                  )}
                </div>
                <div className={styles.educationModalSubTitle}>
                  <span>{`Step ${this.props.currentSubStep} of ${this.props.totalStep}`}</span>
                </div>
              </Modal.Title>
            </Modal.Header>

            <Modal.Body className={styles.addEditEducationModalBody}>
              <Row className={styles.educationProofContainer}>
                <Col lg={12} md={12} sm={12} xs={12}>
                  {this.renderDescription(educationLevel)}
                </Col>
              </Row>
              <Row className={styles.degreeCertificateContainer}>
                <Col lg={12} md={12} sm={12} xs={12}>
                  {this.renderHeading(educationLevel)}
                </Col>
                <Col
                  lg={10}
                  md={10}
                  sm={12}
                  xs={12}
                  className={isMobileOnly ? styles.uploadParentContainer : null}
                >
                  <Row style={isMobileOnly ? { display: 'flex', justifyContent: 'center' } : null}>
                    {/* certificate section */}
                    {educationLevel &&
                    this.state.bothCertificateMarksheet.includes(educationLevel) &&
                    this.state.isDateCorrect ? (
                      <>
                        {isMobileOnly ? (
                          <Col sm={10} xs={10}>
                            <Row>
                              <Col sm={12} xs={12} className={styles.takePhotoBtnContainer}>
                                <Button
                                  disabled={
                                    this.state.docUpload.certificate.error ||
                                    this.state.docUpload.certificate.link
                                  }
                                  className={styles.takePhotoBtn}
                                  onClick={this.handleCertificatePhoto}
                                >
                                  Take Photo of degree certifcate
                                </Button>
                              </Col>
                            </Row>
                          </Col>
                        ) : null}
                        {isEmpty(this.state.docUpload.certificate) ||
                        !this.state.docUpload.certificate.link ? (
                          <Col
                            lg={5}
                            md={5}
                            sm={10}
                            xs={10}
                            className={isMobileOnly ? styles.uploadContainer : null}
                          >
                            {this.state.docUpload.certificate.error ? (
                              <RenderErrorUI
                                handleClick={this.clearError}
                                errorText={this.state.docUpload.certificate.error}
                                index={null}
                                type='certificate'
                              />
                            ) : this.state.docUpload.certificate.loading ? (
                              <div className={styles.certificateInputFileContainer}>
                                <Spinner animation='border' variant='primary' />
                              </div>
                            ) : (
                              <>
                                <label className={styles.certificateInputFileContainer}>
                                  <div>
                                    <Image name='certificate_upload_enable.png' />
                                    <p>Add your degree certificate</p>
                                    <Form.Control
                                      id='formControlsFile'
                                      className={styles.attachDocBtn}
                                      accept='image/*,application/pdf'
                                      type='file'
                                      label='File'
                                      onChange={(e) => this.handleFileSelect(e, 'certificate')}
                                    />
                                  </div>
                                </label>
                              </>
                            )}
                          </Col>
                        ) : (
                          // When file is uploaded successfully for certificate
                          <Col
                            lg={5}
                            md={5}
                            sm={10}
                            xs={10}
                            className={isMobileOnly ? styles.uploadContainer : null}
                          >
                            <RenderUploadedFile
                              item={{
                                link: this.state.docUpload.certificate.link,
                                password: this.state.docUpload.certificate.password
                              }}
                              handleImagePreview={this.handleImagePreview}
                              handleDeleteImage={this.handleDeleteImage}
                              type='certificate'
                              index={null}
                              isPdf={this.state.docUpload.certificate.isPdf}
                            />
                          </Col>
                        )}
                      </>
                    ) : null}

                    {/* Grade Sheet Section */}

                    {isMobileOnly && educationLevel ? (
                      <Col sm={10} xs={10}>
                        <Row>
                          <Col sm={12} xs={12} className={styles.takePhotoBtnContainer}>
                            <Button
                              className={styles.takePhotoBtn}
                              onClick={() => this.handleGradesheetPhoto()}
                              disabled={!enableTakePhotoBtn}
                            >
                              Take Photo of mark sheets
                            </Button>
                          </Col>
                        </Row>
                      </Col>
                    ) : null}

                    {this.state.educationCheck && this.state.educationCheck.step1 ? (
                      <>
                        {this.state.docUpload.gradeSheet.length
                          ? renderGradeSheetHavingLength()
                          : null}

                        {this.state.docUpload.gradeSheet.length < 10 &&
                        !this.isImageHavingError() &&
                        !this.state.noGradeSheetCheckbox
                          ? renderUploadGradeSheet()
                          : null}
                        {/* {this.state.noGradeSheetCheckbox && (
                        <Col
                          lg={5}
                          md={5}
                          sm={10}
                          xs={10}
                          className={isMobileOnly ? styles.uploadContainer : null}
                        >
                          <div className={styles.disabledInputFileContainer}>
                            <Image name='disable_doc_icon.png' />
                            <p>Mark sheet disabled</p>
                          </div>
                        </Col>
                      )} */}
                      </>
                    ) : null}
                  </Row>
                </Col>
              </Row>
              {this.state.showImagePreviewModal && (
                <Row>
                  <Col lg={12} md={12} sm={12} xs={12}>
                    <ImagePreviewModal
                      showImagePreviewModal={this.state.showImagePreviewModal}
                      handleImagePreview={this.handleImagePreview}
                      imagePreviewUrl={this.state.imagePreviewUrl}
                    />
                  </Col>
                </Row>
              )}
              {isMobileOnly && this.state.takeCertificatePhoto && (
                <BGVCamera
                  type='single'
                  showBgvCameraModal={this.state.takeCertificatePhoto}
                  handleCameraModal={this.handleCertificatePhoto}
                  handleSingleUpload={this.handleCertificateUpload}
                  isCameraUploadError={this.state.isCameraUploadError}
                />
              )}
              {isMobileOnly && this.state.takeGradesheetPhoto && (
                <BGVCamera
                  type='multiple'
                  showBgvCameraModal={this.state.takeGradesheetPhoto}
                  handleCameraModal={this.handleGradesheetPhoto}
                  handleMultipleUpload={this.handleGradesheetUpload}
                  isCameraUploadError={this.state.isCameraUploadError}
                  index={
                    this.state.docUpload.gradeSheet.length && !this.isImageHavingError()
                      ? this.state.docUpload.gradeSheet.length
                      : this.state.docUpload.gradeSheet.length && this.isImageHavingError()
                      ? this.state.docUpload.gradeSheet.length - 1
                      : this.state.docUpload.gradeSheet.length
                  }
                />
              )}
            </Modal.Body>

            <Modal.Footer className={styles.educationSubmitBtn}>
              <div>
                <Button
                  className={styles.cancelBtn}
                  onClick={(e) => {
                    this.props.prevSubStep();
                  }}
                >
                  {'Go Back'}
                </Button>
                <Button
                  className={!enableBtn ? styles.disableBtn : styles.activeBtn}
                  disabled={!enableBtn}
                  type='button'
                  onClick={() => this.handleSubmit()}
                >
                  {'Save'}
                </Button>
              </div>
            </Modal.Footer>
          </div>
        </Modal>
        {this.state.showPasswordProtectedModal && (
          <PasswordProtectedModal
            submitHandler={this.submitHandlerPasswordModal}
            subShow={this.state.showPasswordProtectedModal}
            checkType={'education'}
            SubOnHide={this.modalHide}
          />
        )}
      </>
    );
  }
}

export default AddEditUpload;
